type Props = {
    data: any;
  };
  
  const AllValue = ({ data }: Props) => {
    if (!data) {
      return <div className="p-4">Tidak ada data tersedia</div>;
    }
  
    return (
      <div className="space-y-4 mt-4">
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">{data.name}</h2>
        </div>
  
        <div className="space-y-4">
          {data.result.map((item: any, index: number) => (
            <div
              key={index}
              className="p-4 border border-gray-200 rounded-lg bg-white hover:shadow-md transition-shadow"
            >
              <div className="mb-2">
                <p className="text-sm font-medium text-gray-600">
                  Pertanyaan {index + 1}
                </p>
                <h3 className="text-base font-semibold text-gray-900 mt-1">
                  {item?.question}
                </h3>
              </div>
  
              <div className="mt-3 pl-4 border-l-4 border-blue-400 bg-blue-50 py-2 px-3 rounded">
                <p className="text-sm text-gray-600">Jawaban:</p>
                <p className="text-base font-medium text-gray-900">
                  {item?.answer?.label || item?.answer?.value || "-"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default AllValue;
  